<template>
  <div>
    <ValidationObserver ref="form">
        <div>
          <div class="vx-row">
            <div class="vx-col w-full">
              <h3 class="mb-4">
                <strong>{{ $t('InfoGeneral') }}</strong>
              </h3>
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <vx-input-group class="mb-2 mt-3">
                <ValidationProvider name="Nombre" rules="required" v-slot="{ errors }">
                  <vs-input label-placeholder="Nombre" v-model="name" class="w-full" />
                  <p class="text-danger">{{ errors[0] }}</p>
                </ValidationProvider>
              </vx-input-group>
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <vx-input-group class="mb-2 mt-3">
                <label>{{ $t('Imagen') }}</label>
                <ImageDropzone ref="images"></ImageDropzone>
              </vx-input-group>
            </div>
            <div class="vx-col w-full">
              <vx-input-group class="mb-2 mt-3">
                <ValidationProvider name="Descripción" rules="required" v-slot="{ errors }">
                  <p>{{ $t('Descripcion') }}</p>
                  <vs-textarea v-model="description" rows="6" />
                  <p class="text-danger">{{ errors[0] }}</p>
                </ValidationProvider>
              </vx-input-group>
            </div>
            <div class="vx-col md:w-1/2 w-full mt-6">
              <h3 class="mb-4">
                <strong>{{ $t('product.Inventario') }}</strong>
              </h3>
              <vs-table ref="table" pagination :max-items="itemsPerPage" search :data="data">
                <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                  <!-- ITEMS PER PAGE -->
                  <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
                    <div
                      class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
                    >
                      <span class="mr-2"
                        >{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
                        {{ data.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : data.length }} of
                        {{ data.length }}</span
                      >
                      <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                    </div>
                    <vs-dropdown-menu>
                      <vs-dropdown-item @click="itemsPerPage = 6">
                        <span>6</span>
                      </vs-dropdown-item>
                      <vs-dropdown-item @click="itemsPerPage = 10">
                        <span>10</span>
                      </vs-dropdown-item>
                      <vs-dropdown-item @click="itemsPerPage = 15">
                        <span>15</span>
                      </vs-dropdown-item>
                      <vs-dropdown-item @click="itemsPerPage = 20">
                        <span>20</span>
                      </vs-dropdown-item>
                    </vs-dropdown-menu>
                  </vs-dropdown>
                </div>

                <vs-pagination v-model="currentPage" :max="maxPages < 5 ? 5 : 10" :total="maxPages" @input="normalizeTotalPages(data.length / itemsPerPage)"/>

                <template slot-scope="{ data }">
                  <draggable :list="data" :group="{ name: 'dishes', pull: 'clone', put: false }" tag="tbody">
                    <tr :key="index" v-for="(item, index) in data">
                      <td
                        class="td vs-table--td"
                        v-if="dataColumns[indexField].visible && showItem(item)"
                        data="field"
                        :key="keyField"
                        v-for="(field, keyField, indexField) in item"
                      >
                        <div v-if="dataColumns[indexField].dataType == 'slot'">
                          <slot :name="field" :item="item"></slot>
                        </div>
                        <span v-html="field" v-else></span>
                      </td>
                    </tr>
                  </draggable>
                </template>
              </vs-table>
            </div>
            <div class="vx-col md:w-1/2 w-full mt-6">
              <h3 class="mb-4">
                <strong>{{ $t('DetalleCarta') }}</strong>
              </h3>
              <draggable :list="groups" :group="{ name: 'Grupos', pull: false, put: false }" class="p-2 cursor-move">
                <vs-list class="mt-5" v-for="(group, indexGroup) in groups" :key="indexGroup">
                  <vx-input-group class="mb-4">
                    <template slot="append">
                      <div class="append-text btn-addon">
                        <vs-button color="rgb(167, 167, 167)" type="filled">
                          <font-awesome-icon icon="arrows-alt-v" class="w-5 h-5 stroke-current" />
                        </vs-button>
                        <vs-button color="primary" type="border" @click="deleteGroup(indexGroup)">
                          <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" />
                        </vs-button>
                      </div>
                    </template>
                    <vs-input v-model="group.name" class="w-full" placeholder="Nombre del grupo" />
                  </vx-input-group>
                  <draggable :list="group.dishes" :group="{ name: group.name, put: true }" class="p-2 cursor-move">
                    <vs-list-item
                      v-for="(dish, indexDish) in group.dishes"
                      :key="indexDish"
                      :title="dish.name"
                      :subtitle="dish.description"
                    >
                      <vs-button
                        color="danger"
                        type="border"
                        size="small"
                        class="ml-3"
                        @click="deleteDish(indexGroup, indexDish)"
                      >
                        <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" />
                      </vs-button>
                    </vs-list-item>
                  </draggable>
                </vs-list>
              </draggable>
              <vs-button @click="addGroup"> {{ $t('menu.AnyadirGrupo') }}</vs-button>
            </div>
            <div class="vx-col w-full text-right">
              <vs-button depressed color="success" type="border" class="mr-2" @click.prevent="handleSubmit">
                {{ $t('carta.CrearCarta') }}
              </vs-button>
            </div>
          </div>
        </div>
    </ValidationObserver>
  </div>
</template>
<script>
import draggable from 'vuedraggable';
import ImageDropzone from '../ImageDropzone';
import { mapActions, mapGetters } from 'vuex';
export default {
  components: {
    ImageDropzone,
    draggable,
  },
  data () {
    return {
      name: '',
      description: '',
      dataColumns: [
        { caption: 'ID', visible: false },
        { dataField: 'move', caption: '', dataType: 'text', visible: true },
        { caption: 'Imagen', dataType: 'image', visible: true },
        { dataField: 'name', caption: 'Nombre', dataType: 'text', visible: true },
        { dataField: 'size', caption: 'Tamaño', dataType: 'text', visible: true },
        { dataField: 'price', caption: 'Precio', dataType: 'text', visible: true },
        { caption: 'Descripción', dataType: 'text', visible: false },
      ],
      dataColumnsPaged: null,
      currentPageNumber: 1,
      itemsPerPage: 15,
      groups: [
        {
          name: 'Entrantes',
          dishes: [],
        },
        {
          name: 'Segundos',
          dishes: [],
        },
        {
          name: 'Postres',
          dishes: [],
        },
        {
          name: 'Bebidas',
          dishes: [],
        },
      ],
    };
  },
  created () {
    this.refreshDishes({ language: this.language });
  },
  computed: {
    ...mapGetters({
      itemsDishes: 'getDishes',
      dish: 'getDish',
      currentRestaurant: 'getCurrentRestaurant',
      language: 'getCurrentLanguage',
    }),
    currentPage : {
      get () {
        return this.currentPageNumber
      },
      set (currentPageNumber) {
        this.currentPageNumber = currentPageNumber
        return this.currentPageNumber
       }
    },
    data () {
      const items = this.itemsDishes;
      const results = [];
      const placeholder = process.env.VUE_APP_IMAGE_PLACEHOLDER;

      items.forEach(function (item, index) {
        if (items[index].active === 1) {
          const dish = {
            id: items[index].id,
            move: '<div style="width: 50px; height: 50px;" class="flex items-center justify-center" ><i class="fas fa-arrows-alt-h w-5 h-5 stroke-current"></i></div>',
            image: `<img src="${placeholder}" style="width: 75px;" class="product-img" >`,
            name: items[index].name,
            size: items[index].size,
            price: items[index].price,
            description: items[index].description,
          };
          if (items[index].images[0]) {
            dish.image = `<img src="${items[index].images[0].path}" style="width: 75px;" class="product-img" >`;
          }
          results.push(dish);
        }
      }, items);
      return results;
    },
  },
  methods: {
    ...mapActions({
      createCarte: 'createCarte',
      refreshDishes: 'refreshDishes',
    }),
    normalizeTotalPages (totalPages) {
      this.maxPages = Math.ceil(totalPages);
      this.dataColumnsPaged = this.data.slice((this.currentPage * this.itemsPerPage) - this.itemsPerPage, (this.currentPage * this.itemsPerPage));
    },
    checkImages(){
        global.jQuery = require('jquery');
        var $ = global.jQuery;
        const vsSelectedCategories=document.getElementsByClassName('dz-preview')[0];
        if(vsSelectedCategories!==undefined&&vsSelectedCategories)return true;
        else return false;
      },
    handleSubmit () {
      let someGroupEmpty = false;

      this.$refs.form.validate().then((success) => {
        const formData = this.createFormData();

        if (!this.checkImages()) {
          success = false;
        }
        if (!success) {
          setTimeout(() => {
            let textAux = '';
            const errors = this.$refs.form.errors;
            if(errors&&errors!==undefined){
              Object.keys(errors).forEach((key) => {
                const error = errors[key];
                if (error.length) {
                  error.forEach(function (text) {
                    textAux += `<p>${text}</p>`;
                  });
                }
              });
            }
            if (!this.checkImages()) {
              textAux += "<p>El campo Imágenes es obligatorio</p>";
            }
            this.$store.commit('notifications', {
              title: 'Existen errores en el formulario.',
              color: 'danger',
              text: textAux,
            });
            this.$store.commit('showNotifications', true);
          }, 100);
          return;
        }

        this.groups.forEach(group => {
          if (group.dishes.length === 0) {
            someGroupEmpty = true;
          }
        });

      if (someGroupEmpty) {
          this.$store.commit('notifications', {
              title: 'Existen errores en el formulario.',
              color: 'danger',
              text: 'Existe algún grupo vacío.',
          });
          this.$store.commit('showNotifications', true);
          return ;
      }

        this.submitted = true;

        //const formData = this.createFormData();

        this.createCarte({ carte: formData, language: this.language });

        function isFile(input) {
          if ("File" in window && input instanceof File) return true;
          else return false;
        }

        // Wait until the models are updated in the UI
        this.$nextTick(() => {
          this.$refs.form.reset();
        });
      });
    },
    addGroup() {
      const grupo = {
        name: 'Nuevo grupo',
        dishes: [],
      };
      this.groups.push(grupo);
    },
    deleteGroup(index) {
      this.groups.splice(index, 1);
    },
    deleteDish(indexGroup, indexDish) {
      this.groups[indexGroup].dishes.splice(indexDish, 1);
    },
    createFormData() {
      const data = this.$refs.images.getFormData();
      data.append('name', this.name);
      data.append('description', this.description);
      data.append('restaurant_id', this.currentRestaurant);

      for (let i = 0; i < this.groups.length; i++) {
        const arrayDishes = new Array();
        for (let x = 0; x < this.groups[i].dishes.length; x++) {
          arrayDishes.push(this.groups[i].dishes[x].id);
        }
        const group = {
          name: this.groups[i].name,
          dishes: arrayDishes,
        };
        data.append(`groups[${i}]`, JSON.stringify(group));
      }

      return data;
    },
    showItem(item) {
      let show = true;
        this.groups.forEach(group => group.dishes.find(element => {
          if (element.name === item.name) {
            show = false;
          }
      }))

      return show;
    }
  },
};
</script>
<style></style>
